import React, { useEffect, useState } from 'react'
import Select from 'react-select';
import queryString from 'query-string';

import PatientSearch from './PatientSearch';
import ParticipantSearch from './ParticipantSearch';
import LocationOption from '../../../../_components/Options/LocationOption';

export default function SearchFilters({ currentUser, history }) {

  const [status, setStatus] = useState();
  const [patient, setPatient] = useState()
  const [participant, setParticipant] = useState()
  const [location, setLocation] = useState()

  useEffect(() => {
    const queryParams = queryString.parse(history.location.search);

    setStatus(queryParams.status || '')

    if (queryParams.userId) {
      setParticipant({ value: parseInt(queryParams.userId), label: queryParams.user})
    } else {
      setParticipant(false)
    }

    if (queryParams.patientId) {
      setPatient({ value: parseInt(queryParams.patientId), label: queryParams.patient})
    } else {
      setPatient(false)
    }

    if (queryParams.locationId) {
      setLocation({ value: parseInt(queryParams.locationId), label: queryParams.location})
    } else {
      setLocation(false)
    }

  }, [history.location.search])

  const statusSelected = [{ value: 'open', label: 'Open' }, { value: 'closed', label: 'Closed' }].find((type) => {
    return type.value === status;
  });

  return (
    <div className="card axs-shadow">
      <div className="card-header">
        <h5>Search Filters</h5>
      </div>

      <div className="card-body">
        <form>
          <div className="form-group">
            <button onClick={() => {          
              const urlParams = {
                page: 1,
                user: `${currentUser.FirstName} ${currentUser.LastName}`, 
                userId: currentUser.UserId,
              }

              history.push(`/messages?${queryString.stringify(urlParams)}`)
            }} className="btn btn-success btn-block" type="button">My Messages</button>
          </div>

          <hr />

          <div className="form-group">
            <label htmlFor="patient">Patient</label>
            <PatientSearch
              patient={patient}
              handleSelected={(patient) => {
                const urlParams = queryString.parse(history.location.search);

                urlParams.page = 1
                urlParams.patient = patient ? patient.label : ''
                urlParams.patientId = patient ? patient.value : ''

                history.push(`/messages?${queryString.stringify(urlParams)}`)
              }}
            />
          </div>

          <div className="form-group">
            <label htmlFor="user">User</label>
            <ParticipantSearch
              participant={participant}
              placeholder='User'
              handleSelected={(participant) => {
                const urlParams = queryString.parse(history.location.search);

                urlParams.page = 1
                urlParams.user = participant ? participant.label : ''
                urlParams.userId = participant ? participant.value : ''

                history.push(`/messages?${queryString.stringify(urlParams)}`)
              }}
            />
          </div>

          <div className="form-group">
            <label htmlFor='location'>Location</label>
            <LocationOption defaultValue={location ? location.value : false}
              handleSelected={(id, label) => {
                const urlParams = queryString.parse(history.location.search);

                urlParams.page = 1
                urlParams.locationId = id
                urlParams.location = label
                
                history.push(`/messages?${queryString.stringify(urlParams)}`)
              }} />
          </div>

          <div className="form-group">
            <label htmlFor="status">Status</label>
            <Select
              placeholder="Status"
              isClearable={true}
              options={[{ value: 'open', label: 'Open' }, { value: 'closed', label: 'Closed' }]}
              value={statusSelected || ''}
              onChange={(selected) => {
                const urlParams = queryString.parse(history.location.search);

                urlParams.page = 1
                urlParams.status = selected ? selected.value : ''

                history.push(`/messages?${queryString.stringify(urlParams)}`)
              }}
            />
          </div>
        </form>
      </div>

      <div className="card-footer">
        <button
          type="button"
          onClick={() => {
            history.push('/messages')
          }}
          className="btn btn-link btn-block text-center">Clear Filters</button>
      </div>
    </div>
  )
}
